import React from 'react';

import { Card, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const NotFound = React.memo(() => {
  const { t } = useTranslation();

  return (
    <Stack>
      <Card className="align-items-center p-5">
        <Typography variant="h1">{t('not_found.info')}</Typography>
      </Card>
    </Stack>
  );
});

export default NotFound;
